/**
 * @file 教师管理页
 * @description 侧栏「教师管理」对应页面：列表与新增。
 *
 * @whenToUse 路由 `/teachers`。
 * @whenNotToUse 其他业务菜单页。
 */

import { TeacherPanel } from '@/components/pages/teacher-page/teacher-panel.tsx'

export function TeacherPage() {
  return <TeacherPanel />
}
